import React from 'react';
import { Route,Switch } from 'react-router-dom'
import './App.css' //reset.css
//page
import Main from './components/Main';
import Header from './components/Header';
import WordAdd from './components/WordAdd';
import NotFound from './components/NotFound';
import Modify from './components/Modify';
//로드할때 필요, 리덕스 업데이트 훅
import {loadWordFB} from './redux/modules/word';
import { useDispatch } from "react-redux";



function App() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(loadWordFB());
  }, [dispatch]); //이거 안써주면, 화면에 단어 안붙음 디스패치 빼면, 무한루프에 빠짐..
  
  return (
    <div className="App">
      <Header />
      <Switch>
        <Route path ="/" exact component={Main}/>
        <Route path ="/word/add"  component={WordAdd}/>
        <Route path ="/modify/:word_id" component={Modify} />
        <Route component={NotFound} />
      </Switch>
    </div>
  );
}

export default App;
